module.exports = __webpack_public_path__ + "static/media/TooltipInfo.d4a08040.svg";